import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'
import { TRPCClientErrorLike } from '@trpc/client'

type inputType = RouterInputs['DropManager']['getGroupsOfSecretCodes']
type queryOptionsType = ReactQueryOptions['DropManager']['getGroupsOfSecretCodes']
type outputType = RouterOutputs['DropManager']['getGroupsOfSecretCodes']
type optionsType = UseTRPCInfiniteQueryOptions<'DropManager.getGroupsOfSecretCodes', inputType, outputType, TRPCClientErrorLike<any>>

export const useGetInfinityGroupsOfSecretCodes = (input: inputType, options?: optionsType) =>
    api.DropManager.getGroupsOfSecretCodes.useInfiniteQuery(input, {
        ...options,
        queryKey: ['DropManager.getGroupsOfSecretCodes', input],
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        initialCursor: undefined,
        staleTime: 15 * 60 * 1000, // 15 mins
    })

export const useGetGroupsOfSecretCodes = (input: inputType, options?: queryOptionsType) =>
    api.DropManager.getGroupsOfSecretCodes.useQuery(input, {
        ...options,
        queryKey: ['DropManager.getGroupsOfSecretCodes', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
